
import { defineComponent, PropType, computed } from 'vue';

import { UserCreation } from '@/types';

import { domains } from '@/utils';

export default defineComponent({
  props: {
    creation: {
      type: Object as PropType<UserCreation>,
      required: true,
    },
  },
  setup(props) {
    const iframeUrl = computed(() => {
      if (props.creation) {
        const cover = props.creation.userCreationCover;
        let sb3 = props.creation.userCreation;

        if (!(sb3.indexOf('//') === 0 || sb3.indexOf('http') === 0)) {
          sb3 = '/' + sb3;
        }

        return `${domains.contestIdeDomain}/scratchide/#/pcPlayer?url=${sb3}&cover=${cover}`;
      }
      return '';
    });

    return {
      iframeUrl,
    };
  },
});
